import { useTranslation } from 'react-i18next';
import styles from '../styles/components/Testimonials.module.css';

function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className={styles.testimonials}>
      <h2 className={styles.title}>{t('testimonials.title')}</h2>
      <div className={styles.list}>
        <figure className={styles.card}>
          <blockquote className={styles.block}>
            <span className={styles.quote}>“</span>
            {t('testimonials.review1')}
          </blockquote>
          <figcaption>— John D.</figcaption>
        </figure>

        <figure className={styles.card}>
          <blockquote className={styles.block}>
            <span className={styles.quote}>“</span>
            {t('testimonials.review2')}
          </blockquote>
          <figcaption>— John D.</figcaption>
        </figure>

        <figure className={styles.card}>
          <blockquote className={styles.block}>
            <span className={styles.quote}>“</span>
            {t('testimonials.review3')}
          </blockquote>
          <figcaption>— John D.</figcaption>
        </figure>
      </div>
    </section>
  );
}

export default Testimonials;
